import { Component, ViewChild, Input, OnInit, AfterViewInit } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { TemaService, TemaColores } from '../../../providers/tema.service';


@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html'
})
export class BarChartComponent implements OnInit, AfterViewInit {
  dibujarGrafico: boolean = false;
  public barChartLabels: string[] = [];
  public barChartData: any[] = [
    { data: [], label: 'Creadas' },
    { data: [], label: 'Perdidas' },
    { data: [], label: 'Vendidas' },
    { data: [], label: 'Autorizadas' }
  ];

  @Input() public set datos(datos) {
    if (datos) {
      datos.forEach((valores, index: number) => {
        this.barChartLabels.push(datos[index].fecha);
        this.barChartData[0].data.push(datos[index].creadas);
        this.barChartData[1].data.push(datos[index].perdidas);
        this.barChartData[2].data.push(datos[index].vendidas);
        this.barChartData[3].data.push(datos[index].autorizadas);
      });
    }

    this.dibujarGrafico = true;
  }

  @ViewChild(BaseChartDirective) grafico: BaseChartDirective; // referencia al objeto chart (para saber más: "ctrl + click" sobre BaseChartDirective)

  public barChartOptions: any = {
    scaleShowVerticalLines: true,
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0, // on load el gráfico no usamos animaciones
      onComplete: function (animation) {
        animation.chart.options.animation.duration = 1000; // luego del on load seteamos la animacion en 1000
      }
    },
    legend: { position: 'top', labels: {} },
    scales: {
      xAxes: [{
        gridLines: {},
        ticks: {}
      }],
      yAxes: [{
        gridLines: {},
        ticks: {
          beginAtZero: true // el eje y empieza en 0
        }
      }]
    }
  };

  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  public barChartColors: Array<any> = [
    // Creadas
    {
      backgroundColor: 'rgba(255, 173, 92, 0.4)',
      borderColor: 'rgb(255, 173, 92)',
      borderWidth: 1
    },
    // Perdidas
    {
      backgroundColor: 'rgb(255, 122, 150, 0.4)',
      borderColor: 'rgb(255, 122, 150)',
      borderWidth: 1
    },
    // Vendidas
    {
      backgroundColor: 'rgb(84, 176, 238, 0.4)',
      borderColor: 'rgb(84, 176, 238)',
      borderWidth: 1
    },
    // Autorizadas
    {
      backgroundColor: 'rgb(102, 201, 201, 0.4)',
      borderColor: 'rgb(102, 201, 201)',
      borderWidth: 1
    }
  ];

  constructor(
    private temaService: TemaService
  ) { }

  ngOnInit(): void {
    this.temaService.temaChange.subscribe((temaNuevo: TemaColores) => {
      this.actualizarColores(temaNuevo);
    });
  }

  ngAfterViewInit(): void {
    // inicializar grafico con los colores del tema seleccionado
    this.actualizarColores(this.temaService.getColores());
  }

  actualizarColores(colores: TemaColores): void {
    //   // si cambia el tema actualizamos el canvas con los nuevos colores
    this.barChartOptions.legend.labels.fontColor = colores.foreground.getPropertyValue('color');
    this.barChartOptions.scales.xAxes[0].gridLines.zeroLineColor = colores.foreground.getPropertyValue('background-color');
    this.barChartOptions.scales.xAxes[0].gridLines.color = colores.foreground.getPropertyValue('background-color');
    this.barChartOptions.scales.xAxes[0].ticks.fontColor = colores.foreground.getPropertyValue('background-color');
    this.barChartOptions.scales.yAxes[0].gridLines.zeroLineColor = colores.foreground.getPropertyValue('background-color');
    this.barChartOptions.scales.yAxes[0].gridLines.color = colores.foreground.getPropertyValue('background-color');
    this.barChartOptions.scales.yAxes[0].ticks.fontColor = colores.foreground.getPropertyValue('background-color');

    // aplicar los options del grafico  
    if (this.grafico) {
      this.grafico.ngOnInit();
    }
  }

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }
}